import React from 'react';

const HeroSection = ({ backgroundImage, title, subtitle, children }) => {
  return (
    <section className="relative h-screen">
      {/* Arka plan görseli + beyaz gradyan overlay */}
      <div className="absolute inset-0 z-0">
        <div
          className="w-full h-full bg-cover bg-center"
          style={{ backgroundImage: `url('${backgroundImage}')` }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-white/80 via-white/40 to-transparent" />
      </div>

      {/* İçerik katmanı */}
      <div className="relative z-10 flex flex-col justify-center items-center h-full text-center px-4 text-black">
        <h2 className="text-5xl md:text-7xl font-playfair font-semibold max-w-4xl mx-auto leading-tight">
          {title}
        </h2>
        {subtitle && (
          <p className="text-lg md:text-xl mt-6 mb-8">{subtitle}</p>
        )}
        {children}
      </div>
    </section>
  );
};

export default HeroSection;
